// extracted by mini-css-extract-plugin
export default {"divider":"SectionDivider_divider__h6xGw","divider__line":"SectionDivider_divider__line__v8s-a","divider__icon":"SectionDivider_divider__icon__0YhW0"};